export const appBarMeta = {
	"product-home": {
		title: "Study-Pack",
		description:
			"Premium materials to help you learn and prepare for your exam",
	},
	"practice-tests": {
		title: "Practice Tests",
		description:
			"Take practice tests to assess your exam readiness, strengths, and opportunities for improvement",
	},
	store: {
		title: "Test-Prep Store",
		description: "Maximize your exam readiness with premium study materials",
	},
	leaderboard: {
		title: "navbar.leaderboard",
		description: "appbar.leaderboard.description",
	},
	profile: {
		title: "Profile",
		description: "View your profile",
	},
	progress: {
		title: "navbar.progress",
		description: "appbar.progress.description",
	},
	modules: {
		title: "navbar.modules",
		description:
			"Work through ethics modules with scenarios, feedback, and progress tracking",
	},
};
